/**
 * Tire PDP brand-browse mode: model-only view until shopper opts into sizes or vehicle search.
 */
(function () {
  var BROWSE_PARAM = "browse";
  var BROWSE_VALUE = "brand";
  var CONTEXT_KEY = "specr_tire_search_context";
  var PDP_RETURN_KEY = "specr_tire_pdp_return";
  var PLACEHOLDER_LABEL = "Choose your size";

  function getParams() {
    return new URLSearchParams(window.location.search);
  }

  function hasVariantParam() {
    return !!getParams().get("variant");
  }

  function isBrowseFromUrl() {
    return getParams().get(BROWSE_PARAM) === BROWSE_VALUE && !hasVariantParam();
  }

  function readSearchContext() {
    try {
      var raw = sessionStorage.getItem(CONTEXT_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function isBrowseFromStorage() {
    var ctx = readSearchContext();
    if (!ctx || !ctx.vendor) return false;
    if (ctx.size || ctx.vin || ctx.vehicleId) return false;
    if (ctx.year && ctx.make && ctx.model) return false;
    return true;
  }

  function isBrowseMode() {
    if (hasVariantParam()) return false;
    return isBrowseFromUrl() || isBrowseFromStorage();
  }

  function getAddToCartForm() {
    return document.querySelector(
      'form[data-type="add-to-cart-form"], form[action*="/cart/add"]'
    );
  }

  function readVariantSpecsData() {
    var el = document.getElementById("tire-variant-specs-data");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function minVariantPriceCents(data) {
    var min = null;
    Object.keys(data || {}).forEach(function (key) {
      var row = data[key];
      if (!row || row.price == null) return;
      var cents = parseInt(String(row.price), 10);
      if (isNaN(cents) || cents <= 0) return;
      min = min == null ? cents : Math.min(min, cents);
    });
    return min;
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return "";
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function setPriceFromLabel(label) {
    var priceBlock = document.querySelector('[id^="price-"]');
    if (!priceBlock) return;
    var regular = priceBlock.querySelector(
      ".price-item--regular, .price-item--sale, .price__regular .price-item--regular"
    );
    if (regular) regular.textContent = label;
    var stickyCurrent = document.querySelector(".tire-pdp-sticky-atc__current");
    if (stickyCurrent) stickyCurrent.textContent = label;
  }

  function setAddToCartEnabled(enabled) {
    var form = getAddToCartForm();
    if (!form) return;
    var submits = form.querySelectorAll('[type="submit"], button[name="add"]');
    submits.forEach(function (btn) {
      btn.disabled = !enabled;
      btn.setAttribute("aria-disabled", enabled ? "false" : "true");
      if (!enabled) {
        btn.dataset.browseDisabled = "1";
      } else {
        delete btn.dataset.browseDisabled;
      }
    });
    var stickyBtn = document.getElementById("tire-pdp-sticky-submit");
    if (stickyBtn) {
      stickyBtn.disabled = !enabled;
      stickyBtn.setAttribute("aria-disabled", enabled ? "false" : "true");
    }
    form.dataset.browseMode = enabled ? "0" : "1";
  }

  function clearVariantSelection() {
    var form = getAddToCartForm();
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) {
      idInput.value = "";
      idInput.removeAttribute("value");
    }
  }

  function navigateToVariant(variantId) {
    if (!variantId) return;
    var url = new URL(window.location.href);
    url.searchParams.set("variant", String(variantId));
    url.searchParams.delete(BROWSE_PARAM);
    window.location.assign(url.pathname + url.search + url.hash);
  }

  function prepareVariantPicker() {
    var selects = document.querySelectorAll('variant-selects select[name^="options"]');
    if (!selects.length) return null;

    selects.forEach(function (select) {
      var placeholder = select.querySelector('option[data-browse-placeholder="1"]');
      if (!placeholder) {
        placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = PLACEHOLDER_LABEL;
        placeholder.setAttribute("data-browse-placeholder", "1");
        select.insertBefore(placeholder, select.firstChild);
      }
      select.value = "";
    });

    return document.querySelector("variant-selects");
  }

  function wireVariantPicker() {
    var variantSelects = document.querySelector("variant-selects");
    if (!variantSelects || variantSelects.dataset.browsePickerWired === "1") return;
    variantSelects.dataset.browsePickerWired = "1";

    variantSelects.addEventListener(
      "change",
      function (event) {
        if (event.target.tagName !== "SELECT") return;
        if (!event.target.value) return;

        var productJsonEl = document.querySelector('[id^="ProductJSON-"]');
        if (!productJsonEl) return;

        var product;
        try {
          product = JSON.parse(productJsonEl.textContent);
        } catch (e) {
          return;
        }

        var selected = Array.prototype.slice
          .call(document.querySelectorAll('variant-selects select[name^="options"]'))
          .map(function (select) {
            return select.value;
          });

        var match = (product.variants || []).find(function (variant) {
          return selected.every(function (value, index) {
            if (!value) return false;
            return variant["option" + (index + 1)] === value;
          });
        });

        if (match && match.id) navigateToVariant(match.id);
      },
      true
    );
  }

  function wireBrowseSizesPanel() {
    var panel = document.getElementById("tire-pdp-browse-sizes-panel");
    if (!panel) return;

    panel.querySelectorAll(".tire-pdp-other-sizes__row[data-variant-id]").forEach(function (row) {
      row.style.cursor = "pointer";
      row.addEventListener("click", function (event) {
        if (event.target.closest("a")) {
          event.preventDefault();
        }
        navigateToVariant(row.getAttribute("data-variant-id"));
      });
    });
  }

  function revealSizesPanel() {
    document.documentElement.classList.add("tire-pdp--browse-sizes-revealed");

    var picker = prepareVariantPicker();
    wireVariantPicker();

    if (picker) {
      picker.scrollIntoView({ behavior: "smooth", block: "center" });
      var select = picker.querySelector('select[name^="options"]');
      if (select) {
        window.setTimeout(function () {
          select.focus();
        }, 300);
      }
    }

    var panel = document.getElementById("tire-pdp-browse-sizes-panel");
    if (panel) panel.hidden = false;
  }

  function wireBanner() {
    var banner = document.getElementById("tire-pdp-brand-browse-banner");
    if (!banner) return;

    var sizesBtn = banner.querySelector('[data-browse-action="sizes"]');
    if (sizesBtn) {
      sizesBtn.addEventListener("click", revealSizesPanel);
    }

    var vehicleLink = banner.querySelector('[data-browse-action="vehicle"]');
    if (vehicleLink) {
      vehicleLink.addEventListener("click", function () {
        try {
          sessionStorage.setItem(
            PDP_RETURN_KEY,
            window.location.pathname + window.location.search
          );
        } catch (e) {}
        var returnPath = encodeURIComponent(
          window.location.pathname + window.location.search
        );
        vehicleLink.href =
          "/pages/tires?pdp_return=" + returnPath + "#vehicle";
      });
    }
  }

  function applyBrowseMode() {
    if (!isBrowseMode()) return;

    document.documentElement.classList.add("tire-pdp--browse-brand");
    var wrap = document.getElementById("tire-fitment-specs-wrap");
    if (wrap) wrap.classList.add("tire-pdp-root--browse-brand");

    var banner = document.getElementById("tire-pdp-brand-browse-banner");
    if (banner) banner.hidden = false;

    var data = readVariantSpecsData();
    var minCents = minVariantPriceCents(data);
    if (minCents != null) {
      setPriceFromLabel("From " + formatMoney(minCents));
    }

    clearVariantSelection();
    setAddToCartEnabled(false);

    var form = getAddToCartForm();
    if (form) {
      form.addEventListener(
        "submit",
        function (event) {
          if (form.dataset.browseMode === "1") {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        true
      );
    }

    wireBrowseSizesPanel();
    wireBanner();
  }

  function init() {
    applyBrowseMode();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
